import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import { userSmartAccount } from "../../components/recoilAtom";
import { useRecoilValue } from "recoil";
import useWeb3 from "../useWeb3";
import {
  getBalance,
  getLiquidityPool,
  CrashGameContract,
} from "../../utils/contractHelpers";
import {
  USDT_CONTRACT_ADDRESS,
  LUCKIFY_CONTRACT_ADDRESS,
  CRASH_GAME_CONTRACT,
} from "../../utils/Enviroment";
import Web3 from "web3";

export const useCheckAllowance = () => {
  const { account } = useWeb3React();
  const smartAccount = useRecoilValue(userSmartAccount);
  const web3 = useWeb3();
  const web4 = new Web3(
    "https://dimensional-serene-wish.base-mainnet.quiknode.pro/384f047fe7195b52a94e84a42dbc1cc3541a48e5/"
  );
  let contract;

  const checkAllowance = useCallback(
    async (accountsend, gameContract) => {
      try {
        contract = await getBalance(USDT_CONTRACT_ADDRESS, web4);
        const allowance = await contract.methods
          .allowance(smartAccount, gameContract)
          .call();
        const formattedAllowance = web4.utils.fromWei(
          String(allowance),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [smartAccount, contract, web4, account]
  );

  const TotalLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web4);
        const userLiquidity = await contract.methods
          .lpBalances(internalAccount)
          .call();
        const formattedAllowance = web4.utils.fromWei(
          String(userLiquidity),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web4]
  );

  const CurrentLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web4);
        const userLiquidity = await contract.methods
          .lpShares(internalAccount)
          .call();
        const formattedAllowance = web4.utils.fromWei(
          String(userLiquidity),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web4]
  );

  const TotalYourReward = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web4);
        const userReward = await contract.methods
          .claimableRewards(internalAccount)
          .call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalShare = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web4);
        const userReward = await contract.methods.totalShares().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalRewards = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web4);
        const userReward = await contract.methods.totalRewards().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  return {
    TotalRewards,
    checkAllowance,
    TotalLiquidityYouProvide,
    CurrentLiquidityYouProvide,
    TotalYourReward,
    TotalShare,
  };
};
